import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/LoginIndex')
  },
  {
    path: '/layout',
    name: 'layout',
    component: () => import('../views/layout/LayoutIndex'),
    redirect: '/welcome',
    children: [
      {
        path: '/welcome',
        name: 'welcome',
        component: () => import('../views/welcome/WelcomeIndex')
      },
      {
        path: '/userrisk',
        name: 'userrisk',
        component: () => import('../views/userrisk/UserriskIndex')
      },
      {
        path: '/userlist',
        name: 'userlist',
        component: () => import('../views/userlist/UserlistIndex')
      },
      {
        path: '/groupapply',
        name: 'groupapply',
        component: () => import('../views/groupapply/GroupapplyIndex')
      },
      {
        path: '/grouplist',
        name: 'grouplist',
        component: () => import('../views/grouplist/GrouplistIndex')
      },
      {
        path: '/causelist',
        name: 'causelist',
        component: () => import('../views/causelist/CauselistIndex')
      },
      {
        path: '/rechargelist',
        name: 'rechargelist',
        component: () => import('../views/rechargelist/RechargelistIndex')
      },
      {
        path: '/withdrawallist',
        name: 'withdrawallist',
        component: () => import('../views/withdrawallist/WithdrawallistIndex')
      },
      {
        path: '/withdrawaAudit',
        name: 'withdrawaAudit',
        component: () => import('../views/withdrawaAudit/withdrawaAuditIndex')
      },
      {
        path: '/redpacketlist',
        name: 'redpacketlist',
        component: () => import('../views/redpacketlist/RedpacketlistIndex')
      },
      {
        path: '/transferlist',
        name: 'transferlist',
        component: () => import('../views/transferlist/TransferlistIndex')
      },
      {
        path: '/addnotice',
        name: 'addnotice',
        component: () => import('../views/addnotice/AddnoticeIndex')
      },
      {
        path: '/systemconfiglist',
        name: 'systemconfiglist',
        component: () => import('../views/systemconfiglist/SystemconfiglistIndex')
      },
      {
        path: '/cronlist',
        name: 'cronlist',
        component: () => import('../views/cronlist/CronlistIndex')
      },
      {
        path: '/changepwd',
        name: 'changepwd',
        component: () => import('../views/changepwd/ChangepwdIndex')
      },
      {
        path: '/changepwd',
        name: 'changepwd',
        component: () => import('../views/changepwd/ChangepwdIndex')
      },
      {
        path: ':pathMatch(.*)',
        component: () => import('../views/NotFound.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  base: '/ddj',
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  const token = localStorage.getItem('token')
  if (token) {
    next()
  } else {
    next('/login')
  }
})

export default router
